import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const GoCashComp = styled.div(
  props => `
  background: ${props.theme.colors.goWhite.base};
  border-radius: 8px;
  margin: ${props.isMweb ? '1rem 0' : '1rem 0 0 0'};
`,
);

export const GoCashTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const GoCashHeader = styled.div(
  props => `
  padding: 1.2rem 1.6rem;
  border-bottom: 1px solid #ebebeb;
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 2rem;
  color: ${props.theme.colors.black};
  display: flex;
  align-items: center;
  justify-content: space-between;
`,
);

export const GoCashDetails = styled.div(
  props => `
  font-size: 12px;
  line-height: 14px;
  color: ${props.theme.colors.downriver.medium};
  padding: 1.2rem 1.6rem;

  & .balance {
    font-weight: 700;
    margin-bottom: 4px;
  }
`,
);

export const ToggleBtn = styled.div(
  props => `
  border-radius: 10px;
  background: ${props.theme.colors.goWhite.base};

`,
);

export const GoCashToogleWrap = styled.div(
  props => `
  display: flex;
  align-items: center;

  & .onText {
    font-size: 12px;
    line-height: 14px;
    font-weight: 700;
    color: ${props.theme.colors.goGreen.base};
    margin-right: 8px;
  }

  & .offText {
    font-size: 12px;
    line-height: 14px;
    font-weight: 700;
    color: ${props.theme.colors.ash.base};
    margin-right: 8px;
  }
`,
);

export const ToggleStatus = styled.div(
  props => `
  width: 40px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  font-weight: 700;
  cursor: pointer;
  position: relative;

  span {
    transition: all 0.3s ease;
  }
  
  &.buttonOff {
    background: ${props.theme.colors.ash.dark};
  }

  &.buttonOn {
    background: ${props.theme.colors.goGreen.light};
  }

  & .off {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background: ${props.theme.colors.ash.base};
    padding: 0px 2px;
    position: absolute;

  }

  & .on {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: ${props.theme.colors.goGreen.base};
    padding: 0px 2px;
    justify-content: center;
    display: flex;
    align-items: center;
    position: absolute;
    transform: translateX(16px);
  }
`,
);

export const TooltipText = styled.span`
  visibility: hidden;
  width: 20rem;
  background-color: ${props => props.theme.colors.goWhite.base};
  color: ${props => props.theme.colors.black.base};
  position: absolute;
  z-index: 10;
  bottom: 125%;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem;
  padding: 1.2rem;
  border-radius: 0.8rem;
  left: -9rem;
  ${textSizes.SmallW1};

  opacity: 0;
  transition: opacity 0.3s;

  /* Tooltip arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%; /* Arrow at the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${props => props.theme.colors.goWhite.base} transparent transparent transparent;
  }
`;

export const Tooltip = styled(ToggleStatus)`
  &.disabled {
    filter: grayscale(1);
    cursor: not-allowed;
  }
  &:hover ${TooltipText} {
    visibility: visible;
    opacity: 1;
  }
`;
